import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from '../../../utils/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from '../action-type.util';

import { IChartTemplateTimeSession, defaultValue } from '../../model/chart-template-time-session.model';

export const ACTION_TYPES = {
  FETCH_CHARTTEMPLATETIMESESSION_LIST: 'chartTemplateTimeSession/FETCH_CHARTTEMPLATETIMESESSION_LIST',
  FETCH_CHARTTEMPLATETIMESESSION: 'chartTemplateTimeSession/FETCH_CHARTTEMPLATETIMESESSION',
  CREATE_CHARTTEMPLATETIMESESSION: 'chartTemplateTimeSession/CREATE_CHARTTEMPLATETIMESESSION',
  UPDATE_CHARTTEMPLATETIMESESSION: 'chartTemplateTimeSession/UPDATE_CHARTTEMPLATETIMESESSION',
  DELETE_CHARTTEMPLATETIMESESSION: 'chartTemplateTimeSession/DELETE_CHARTTEMPLATETIMESESSION',
  RESET: 'chartTemplateTimeSession/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IChartTemplateTimeSession>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type ChartTemplateTimeSessionState = Readonly<typeof initialState>;

// Reducer

export default (state: ChartTemplateTimeSessionState = initialState, action): ChartTemplateTimeSessionState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_CHARTTEMPLATETIMESESSION_LIST):
    case REQUEST(ACTION_TYPES.FETCH_CHARTTEMPLATETIMESESSION):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_CHARTTEMPLATETIMESESSION):
    case REQUEST(ACTION_TYPES.UPDATE_CHARTTEMPLATETIMESESSION):
    case REQUEST(ACTION_TYPES.DELETE_CHARTTEMPLATETIMESESSION):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_CHARTTEMPLATETIMESESSION_LIST):
    case FAILURE(ACTION_TYPES.FETCH_CHARTTEMPLATETIMESESSION):
    case FAILURE(ACTION_TYPES.CREATE_CHARTTEMPLATETIMESESSION):
    case FAILURE(ACTION_TYPES.UPDATE_CHARTTEMPLATETIMESESSION):
    case FAILURE(ACTION_TYPES.DELETE_CHARTTEMPLATETIMESESSION):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_CHARTTEMPLATETIMESESSION_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_CHARTTEMPLATETIMESESSION):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_CHARTTEMPLATETIMESESSION):
    case SUCCESS(ACTION_TYPES.UPDATE_CHARTTEMPLATETIMESESSION):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_CHARTTEMPLATETIMESESSION):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export const apiUrl = 'api/chart-template-time-sessions';

// Actions

export const getEntities: ICrudGetAllAction<IChartTemplateTimeSession> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_CHARTTEMPLATETIMESESSION_LIST,
    payload: axios.get<IChartTemplateTimeSession>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<IChartTemplateTimeSession> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_CHARTTEMPLATETIMESESSION,
    payload: axios.get<IChartTemplateTimeSession>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IChartTemplateTimeSession> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_CHARTTEMPLATETIMESESSION,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IChartTemplateTimeSession> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_CHARTTEMPLATETIMESESSION,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IChartTemplateTimeSession> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_CHARTTEMPLATETIMESESSION,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
